<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <DuplicateReport class="dialog mb-sm-5" :class="{ xs: $vuetify.breakpoint.xsOnly }" />
  </v-container>
</template>

<script>
import DuplicateReport from '../components/duplicate/DuplicateReport.vue';

export default {
  name: 'Duplicate',
  data: () => ({}),
  components: { DuplicateReport }
};
</script>
